import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="security-systems-patrols-road"
export default class extends Controller {
  static targets = ["complexSchedule", "complexDaysOfWeek", "complexTimes", "scheduleDetails"]

  connect() {
    this.toggleScheduleFields()
  }

  toggleScheduleFields() {
    this.complexScheduleTarget.style.display = 'block'
  }

  toggleDay(event) {
    event.currentTarget.classList.toggle('active')
  }

  submitForm(event) {
    event.preventDefault()
    const daysOfWeek = this.complexDaysOfWeekTargets
      .filter(btn => btn.classList.contains('active'))
      .map(btn => btn.dataset.day)
      .join(',')
    const times = this.complexTimesTarget.value
    this.scheduleDetailsTarget.value = `${daysOfWeek}|${times}`

    this.element.submit()
  }
}
